import React, {useEffect, useState} from 'react';
import {Button, FormGroup, Modal, Card} from "components/ui";
import {translate} from "utils/helpers";
import {Col, Row} from "antd";
import {FormInput, FormTextarea} from "components/ui/form";
import {serviceAppSetError} from "services/app.service";
import {useAppState} from "store/module/app.store";
import {useTranslateContext} from "context/TranslateContext";
import {useForm} from "hooks/useForm";

function TranslateFormModal(props) {

    const {languages} = useAppState();
    const {modal, handleModal, tableRow, translateKey, handleSave} = useTranslateContext();
    const [ready, setReady] = useState(false)

    const {values, setField, setValues, setLoading, loading} = useForm({});

    const handleForm = async (item = {}) => {
        const customForm = {};
        languages.filter(i => {
            customForm[i.code] = {
                key: item[i.code],
                text: translate(item[i.code], {lang: i.code})
            }
        })
        await setValues({...customForm});
        setReady(true);
    }

    const handleField = (value, key) => {
        setValues(prevState => {
            return {
                ...prevState,
                [key]: {
                    ...prevState[key],
                    text: value
                }
            }
        });
    }

    const handleClose = () => {
        serviceAppSetError({});
        handleModal('form', false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await handleSave(values);
        if (res) handleClose();
        setLoading(false)
    }

    useEffect(() => {
        handleForm(tableRow);
    }, [tableRow])

    return (
        <Modal
            title={translate('crm.Sidebar.Translates')}
            visible={modal.form}
            onClose={() => handleClose()}
            className="w-full"
        >
            {(ready) && (
                <form onSubmit={handleSubmit}>
                    <Row gutter={[16, 16]}>

                        {languages.length > 0 && languages.map((i, index) => (
                            <Col span={24} key={index}>
                                <FormGroup
                                    label={i.name}
                                    error={`${i.code}.text`}
                                    elementClass={'!h-auto'}
                                >
                                    <FormTextarea
                                        rows={5}
                                        value={values[i.code]?.text}
                                        onChange={e => handleField(e, i.code)}
                                    />
                                </FormGroup>
                            </Col>
                        ))}

                        <Col span={24} className="!flex justify-end">
                            <Button loading={loading} type={'submit'}>
                                {translate('button.Save')}
                            </Button>
                        </Col>
                    </Row>
                </form>
            )}
        </Modal>
    );
}

export default TranslateFormModal;
